import type { FC } from 'react';
import React from 'react';
import type { LinkProps } from '@mui/material';
import { Link } from '@mui/material';

/**
 * I18nLink component to be used to interpolate links in i18n translations with a Trans component.
 * example usage:
 * i18n.json containing the following string:
 * "foo": "By using the service you agree to its <lnk>Terms of Use</lnk>"
 *
 * tsx file containing the following code:
 * <Trans
 *   t={t}
 *   i18nKey="foo"
 *   components={{
 *     lnk: (
 *       <I18nLink
 *         href="https://example.com"
 *         rel="noopener noreferrer"
 *         target="_blank"
 *       />
 *     ),
 *   }}
 * />
 *
 */
const I18nLink: FC<LinkProps> = ({ children, ...props }) => (
  <Link {...props}>{children}</Link>
);

export default I18nLink;
